/* js/selectbox.js */

jQuery( document ).ready(function( $ ) {

    $(function() {
        $('.js-selectBox').selectric({

            disableOnMobile: false,
            nativeOnMobile: false,

            onChange: function() {
                $(this).closest('.formGroup').addClass('selectBox-active');
            }


            /*onClose: function() {
                $(this).closest('.formGroup').addClass('closed');
            }*/
        });

    });

});